import axios from "../../axiosInstance";

const Billing_report = "ob/billing";
const BillingbaseUrl = '/operation';
const MasterbaseUrl = '/master';
const ReportsbaseUrl = '/Reports';

class BillingReportsService {
    reportJobBillDetails(details) {
        return axios.post(Billing_report + '/reportJobBillDetails', details)
    }
    getShipment_mode_details(details) {
        return axios.post(Billing_report + '/getShipment_mode_details', details)
    }
    getBill_type() {
        return axios.get(Billing_report + '/getBill_type')
    }
    insertShipment_mode_details(details) {
        return axios.post(Billing_report + '/insertShipment_mode_details', details)
    }
    getBillPrintTo() {
        return axios.get(Billing_report + '/getBillPrintTo')
    }
    getCurrencyName() {
        return axios.get(BillingbaseUrl + '/getCurrencyName')
    }
    getJobCurrencyDetails(consignmentId) {
        return axios.get(BillingbaseUrl + '/getJobCurrencyDetails?consignmentId=' + consignmentId)
    }
    updateCurrencyRate(details) {
        return axios.put(BillingbaseUrl + '/updateCurrencyRate', details)
    }
    getGstNo(jobNo) {
        return axios.get(ReportsbaseUrl + '/getGstNo?jobNo=' + jobNo)
    }
    InvoiceBillPdfPrint(details) {
        return axios.post(ReportsbaseUrl + '/InvoiceBillPdfPrint', details)
    }
    reportJobDetails(details) {
        return axios.post(Billing_report + '/reportJobDetails', details)
    }
    getDeliveryStateName() {
        return axios.get(MasterbaseUrl + '/getDeliveryStateName')
    }
    showMultipleBill(details) {
        return axios.post(ReportsbaseUrl + '/showMultipleBill', details)
    }
    MultipleInvoiceBillPdfPrint(details) {
        return axios.post(ReportsbaseUrl + '/MultipleInvoiceBillPdfPrint', details)
    }
    getImporter(details) {
        return axios.post(Billing_report + '/getImporter', details)
    }
    getImporterBranch(details) {
        return axios.post(Billing_report + '/getImporterBranch', details)
    }
    getCombinedInvoiceSummary(details) {
        return axios.post(ReportsbaseUrl + '/getCombinedInvoiceSummary', details)
    }
    getCombinedInvoiceDetails(details) {
        return axios.post(ReportsbaseUrl + '/getCombinedInvoiceDetails', details)
    }
    combinedInvoiceSummaryPdf(details) {
        return axios.post(ReportsbaseUrl + '/combinedInvoiceSummaryPdf', details)
    }
    combinedInvoiceDetailsPdf(details) {
        return axios.post(ReportsbaseUrl + '/combinedInvoiceDetailsPdf', details)
    }
    getSupplementaryBillBasedOnJobNo(details) {
        return axios.post(ReportsbaseUrl + '/getSupplementaryBillBasedOnJobNo', details)
    }
    SupplementaryInvoiceBillPdfPrint(details) {
        return axios.post(ReportsbaseUrl + '/SupplementaryInvoiceBillPdfPrint', details)
    }
    showSupplementaryBill(details) {
        return axios.post(ReportsbaseUrl + '/showSupplementaryBill', details)
    }
    getImporterDetail() {
        return axios.get(MasterbaseUrl + '/getImporterDetails')
    }
    selectFwdDetails() {
        return axios.get(Billing_report + '/selectFwdDetails')
    }
    QuotationPdfPrint(details) {
        return axios.post(ReportsbaseUrl + '/QuotationPdfPrint', details)
    }
    getImporterDetails() {
        return axios.get(ReportsbaseUrl + '/getImporterDetails')
    }
    getDeliveryStateNameAll(stateId) {
        return axios.get(MasterbaseUrl + '/getDeliveryStateNameAll?stateId' + stateId)
    }
    getRegionBasedOnState(stateId) {
        return axios.get(MasterbaseUrl + '/getRegionBasedOnState?stateId=' + stateId)
    }
    ///selectBillPaidBy is replaced by it for tallyintigration report.......if anyofother pages need then cal it then use it either erace it
    getbillpaidby() {
        return axios.get(Billing_report + '/getbillpaidby')
    }
    getBillPaidTo() {
        return axios.get(Billing_report + '/getBillPaidTo')
    }
    getBillPaidToSelective() {
        return axios.get(Billing_report + '/getBillPaidToSelective')
    }
    reportTallyIntegration(details) {
        return axios.post(Billing_report + '/reportTallyIntegration', details)
    }
    Excelwrite(details) {
        return axios.post(ReportsbaseUrl + '/write', details)
    }
    reportBillingSummary(details) {
        return axios.post(Billing_report + '/reportBillingSummary', details)
    }
    selectBillPaidBy() {
        return axios.get(Billing_report + '/selectBillPaidBy')
    }
    reportBillingDetails(details) {
        return axios.post(Billing_report + '/reportBillingDetails', details)
    }
    getRegionalOfficeDetails() {
        return axios.get(ReportsbaseUrl + '/getRegionalOfficeDetails')
    }
    getGSTR1Report(details) {
        return axios.post(ReportsbaseUrl + '/getGSTR1Report', details)
    }
    GSTR1_report(details) {
        return axios.post(ReportsbaseUrl + '/GSTR1_report', details)
    }
    getCustomerBillDetailsReport(details) {
        return axios.post(ReportsbaseUrl + '/getCustomerBillDetailsReport', details)
    }
    billDetails_report(details) {
        return axios.post(ReportsbaseUrl + '/billDetails_report', details)
    }
    getVoucherTypeAll(){
        return axios.get(Billing_report+'/getVoucherTypeAll')
    }
    getBankName(){
        return axios.get(BillingbaseUrl+'/getBankName')
    }
    getDashboardDetails(userId,flag){
        return axios.get(BillingbaseUrl+'/getDashboardDetails?userId='+userId+'&flag='+flag);
    }
    getdashboardReport(userId,flag){
        return axios.get(BillingbaseUrl+'/getdashboardReport?userId='+userId+'&flag='+flag);
    }

    get_bill_edit(job_no,Bill_no) {
        return axios.get(BillingbaseUrl + '/get_bill_edit?job_no='+job_no+'&Bill_no='+Bill_no)
    }

    update_bill_status(bill_dto,Bill_no) {
        return axios.put(BillingbaseUrl + '/update_bill_status?flag='+Bill_no,bill_dto)
    }


}
export default new BillingReportsService();